import * as service from './service'
export default {
  namespace: 'acceleratorCardSurePay',
  state: {
    payData: {}
  },
  effects: {
    * toPay ({ payload }, { call, put }) {
      const res = yield call(service.toPay, payload)
      yield put({
        type: 'save',
        payload: {
          payData: typeof res.data === 'string' ? JSON.parse(res.data).data : res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
